import { initializeIPCategory, IPCategory } from "../models/IPCategory";
import { initializeIPContainer, IPContainer } from "../models/IPContainer";
import { initializeIPItem, IPItem } from "../models/IPItem";
import { IPItemValue } from "../models/IPItemValue";
import { initializeIPProject, IPProject, newIPProject } from "../models/IPProject";
import store from "../features/store/store";
import { replaceMyProjectAction } from "../features/sliceReducer/myProjectReducer";
import { IPConfiguration } from "../models/IPConfiguration";

export interface FileInfo {
  bytes?: number[];
  base64StringFile: string;
  fileName: string;
  fileType: string;
}

export interface LocalData {
  name: string;
  date: string;
  project: IPProject;
  isSaveSuccessed: boolean;
}

export default class IPUtility {
  static debugMode = true;
  constructor() { }
  static log(log: string | number | object | undefined | unknown) {
    if (this.debugMode) console.log(log);
  }

  static copyString(value: string) {
    this.setSessionValue("copied", value);
  }
  static getString(original: string = "") {
    const value = this.getSessionValue("copied");
    if (value) return value; else return original;
  }

  // static setLocalProject(project: IPProject, isSaved: boolean) {
  //   const localData: LocalData = {
  //     name: project.name,
  //     date: new Date().toISOString().split('T')[0],
  //     project: project,
  //     isSaveSuccessed: isSaved,
  //   }
  //   localStorage.setItem("localProject", JSON.stringify(localData));
  //   // this.setSessionValue("project", JSON.stringify(project));
  // }

  // static getLocalProject() {
  //   const value = localStorage.getItem("localProject");
  //   if (value) {
  //     const localData = JSON.parse(value) as LocalData;
  //     return localData;
  //   }
  //   else return null;
  // }

  static updateContainerToLocal(container: IPContainer, isSavedSuccess: boolean) {
    const localData = this.getLocalProjectInfo();
    if (localData != null) {
      localData.project.categories.forEach(x => x.containers.forEach(y => { if (y.uid === container.uid) y = container; }));
      localData.isSaveSuccessed = isSavedSuccess;
      this.saveProjectToLocal(localData.project, isSavedSuccess);
    }
  }
  // static getProjectFromLocal() {
  //   // const value = this.getSessionValue("project");
  //   const value = localStorage.getItem("project");
  //   if (value) {
  //     const project = JSON.parse(value) as IPProject;
  //     store.dispatch(replaceMyProjectAction(project));
  //   }
  // }

  static openWord(id: number, userToken: string, fileName: string) {
    const url = `/document/generateDocument/`;
    fetch(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "POST",
      body: JSON.stringify({ id, userToken })
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${fileName}.docx`,
        );
        document.body.appendChild(link);
        link.click();
        link?.parentNode?.removeChild(link);
      });
  }

  static openReview(id: number, userToken: string, fileName: string) {
    const url = `/document/generateReview/`;
    fetch(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "POST",
      body: JSON.stringify({ id, userToken })
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${fileName}.docx`,
        );
        document.body.appendChild(link);
        link.click();
        link?.parentNode?.removeChild(link);
      });
  }

  static downloadSheet(id: number, userToken: string, fileName: string) {
    const url = `/document/ExportSheet/`;
    fetch(url, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "POST",
      body: JSON.stringify({ id, userToken })
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${fileName}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link?.parentNode?.removeChild(link);
      });
  }


  static setSessionValue(key: string, value: string) {
    sessionStorage.setItem(key, value);
  }
  static getSessionValue(key: string) {
    return sessionStorage.getItem(key);
  }

  static setLocalValue(key: string, value: string) {
    localStorage.setItem(key, value);
  }
  static getLocalValue(key: string) {
    return localStorage.getItem(key);
  }

  static setLocalProjectSaved(saved: boolean) {
    const local = this.getLocalProjectInfo();
    this.saveProjectToLocal(local.project, saved);
  }

  static saveProjectToLocal(myproject: IPProject, isSaveSuccessed: boolean) {
    this.log("SAVED to LOCAL");
    const saveData: LocalData = {
      name: myproject.factoryName + " " + myproject.name,
      date: new Date().toISOString().split('T')[0],
      project: myproject,
      isSaveSuccessed: isSaveSuccessed,
    }
    const json = JSON.stringify(saveData);
    this.setLocalValue("myProject", json);
    this.log(json);
  }

  static getLocalProjectInfo(): LocalData {
    const json = this.getLocalValue("myProject");
    this.log(json);
    if (json != null) {
      const localInfo = JSON.parse(json) as LocalData;
      return localInfo;
    } else {
      return {
        name: "", date: "", project: {} as IPProject, isSaveSuccessed: true,
      }
    }
  }

  static restoreLocalProject(): IPProject {
    const localData = this.getLocalValue("myProject");
    if (localData) {
      const myProject = (JSON.parse(localData) as LocalData).project;
      return myProject;
    } else {
      return newIPProject();
    }
  }

  static clearLocalProject() {
    localStorage.removeItem("myProject");
  }
  static timeToString(date: Date): string {
    return date.toISOString().replace('T', ' ').substring(0, 19);
  }
  static getCurrentTime(date: Date): string {
    const dateX = new Date(+date + 3240 * 10000);
    return dateX.toISOString().replace('T', ' ').substring(0, 19);
  }

  static getFullYmdStr(): string {
    //년월일시분초 문자열 생성
    var d = new Date();
    return d.getFullYear() + ". " + (d.getMonth() + 1) + ". " + d.getDate() + " (" + '일월화수목금토'.charAt(d.getUTCDay()) + "), 09 : 00 ~ 17 : 00";
  }

  // UUID 생성
  static generateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  // 내 입력 항목 개수
  static getMyFilledCount(project: IPProject, container: IPContainer): number {
    let total = 0;
    const items = container.items.filter(x => project.noContentItemUIDs.indexOf(x.uid) === -1);
    items.forEach(x => {
      if (x.myItemValue !== undefined) {
        if (x.myItemValue.general.trim() !== "" || x.myItemValue.regulation.trim() !== ""
          || x.myItemValue.recommendation.trim() !== "" || x.myItemValue.instruction.trim() !== "") {
          total++;
        }
      }
    })
    return total;
  }

  // 전체 입력 항목 개수
  static getTotalFilledCount(project: IPProject, container: IPContainer, containMine: boolean = true): number {
    let total = 0;
    const items = container.items.filter(x => project.noContentItemUIDs.indexOf(x.uid) === -1);
    items.forEach(x => {
      if (x.projectItemValues !== undefined) {
        const filled = x.projectItemValues.map(y => y.itemUID).filter((value, index, self) => self.indexOf(value) === index);
        total += filled.length;
        if (containMine && (x.myItemValue.general.trim() !== "" || x.myItemValue.regulation.trim() !== ""
          || x.myItemValue.recommendation.trim() !== "" || x.myItemValue.instruction.trim() !== "")) {
          if (filled.indexOf(x.uid) === -1) total++;
        }
      }
    })

    return total;
  }

  // 입력 내용의 개수 파악
  static countTextLine(content: string, splitKey?: string): number {
    if (splitKey === undefined) splitKey = "!";
    const lines = content.split(splitKey);
    return lines.filter(x => x.trim().length > 0 || x.trim().substring(0, 0) !== "$").length;
  }

  // note 점수 계산 
  // 항목의 자동 점수 
  static getAutoPoint(item: IPItem): number {
    const generalCount = this.countTextLine(item.myItemValue.general) + item.projectItemValues.map(x => this.countTextLine(x.general)).reduce((ty, u) => ty + u, 0);
    const recommendationCount = this.countTextLine(item.myItemValue.recommendation) + item.projectItemValues.map(x => this.countTextLine(x.recommendation)).reduce((ty, u) => ty + u, 0);
    const regulationCount = this.countTextLine(item.myItemValue.regulation) + item.projectItemValues.map(x => this.countTextLine(x.regulation)).reduce((ty, u) => ty + u, 0);
    const instructionCount = this.countTextLine(item.myItemValue.instruction) + item.projectItemValues.map(x => this.countTextLine(x.instruction)).reduce((ty, u) => ty + u, 0);
    const point = regulationCount + instructionCount;
    if (point > 4) return 4;
    if (point > 2) return 6;
    if (point == 0) {
      if (recommendationCount > 0) return 8;
      else if (generalCount > 0) return 10; else return 10;
    }
    return 8;
  }

  // Deprecated
  static getProjectItemPoint(item: IPItem): number {
    const generalCount = item.projectItemValues.map(x => this.countTextLine(x.general)).reduce((ty, u) => ty + u, 0);
    const recommendationCount = item.projectItemValues.map(x => this.countTextLine(x.recommendation)).reduce((ty, u) => ty + u, 0);
    const regulationCount = item.projectItemValues.map(x => this.countTextLine(x.regulation)).reduce((ty, u) => ty + u, 0);
    const instructionCount = item.projectItemValues.map(x => this.countTextLine(x.instruction)).reduce((ty, u) => ty + u, 0);
    const point = regulationCount + instructionCount;
    if (point > 4) return 4;
    if (point > 2) return 6;
    if (point == 0) {
      if (recommendationCount > 0) return 8;
      else if (generalCount > 0) return 10; else return 10;
    }
    return 8;
  }

  // 항목의 입력 점수
  static getItemPoint(project: IPProject, itemUID: number): number {
    let point = 0;
    if (project.isManualPoint && project.manualPointsList !== undefined) {
      const index = project.manualPointsList.findIndex(manualPoint => manualPoint.itemUID === itemUID);
      if (index > -1) point = project.manualPointsList[index].point;
    }
    else {
      point = this.getAutoPoint(this.getItemByUIDs(project, itemUID));
    }
    return point;
  }

  // 중분류 별 점수
  static getContainerPoint(project: IPProject, container: IPContainer): number {
    let point = 0;
    if (container.containerValue.isExclude) return 0;
    container.items.forEach(item => {
      if (project.noContentItemUIDs.indexOf(item.uid) === -1) {
        if (project.isManualPoint) point += this.getItemPoint(project, item.uid);
        else point += this.getAutoPoint(item);
      }
    });
    return point;
  }

  static getProjectAssignedPoint(project: IPProject): number {
    let points = 0;
    project.categories.forEach(x => {
      points += this.getCategoryAssignedPoint(project, x);
    });
    return points;
  }

  static getCategoryAssignedPoint(project: IPProject, category: IPCategory): number {
    let points = 0;
    category.containers.forEach(x => {
      if (!x.containerValue?.isExclude)
        points += this.getContainerAssignedPoint(project, x);
    });
    return points;
  }

  static getContainerAssignedPoint(project: IPProject, container: IPContainer): number {
    let points = 0;
    container.items.forEach(x => {
      if (project.noContentItemUIDs.indexOf(x.uid) === -1) {
        points += 10;
      }
    });
    return points;
  }


  static getAssignedPoint(category: IPCategory, container: IPContainer): number {
    let point = 0;
    if (category.name.indexOf("현장")) {

    } else {
      point = container.items.length * 10
    }
    return point;
  }

  // 대분류 별 점수
  static getCategoryPoint(project: IPProject, category: IPCategory): number {
    let point = 0;
    category.containers.forEach(x => {
      if (!x.containerValue.isExclude) {
        point += this.getContainerPoint(project, x);
      }
    });
    return point;
  }

  // 프로젝트 전체 점수
  static getProjectPoint(project: IPProject): number {
    let point = 0;
    project.categories.forEach(x => {
      point += this.getCategoryPoint(project, x);
    });
    return point;
  }

  static getEvalLevel(totalPoints: number) {
    if (totalPoints >= 90) return "P";
    if (totalPoints >= 80) return "S";
    if (totalPoints >= 70) return "M+";
    return "M-";
  }

  static CalculateProjectPoints(project: IPProject): IPProject {
    const categoryContants = [5, 5.5, 3.5, 17.0];
    const containerContants = [4.0, 5.5, 8.5, 8.0, 5.0, 3.0, 7.0, 4.0, 3.0];
    const scoreProject = JSON.parse(JSON.stringify(project)) as IPProject;

    scoreProject.totalAssginedPoints = 0;
    scoreProject.totalEvalPoints = 0;
    scoreProject.totalConvertPoints = 0;

    let oneCategoryIndex = 0;
    let categoryIndex = 0;

    scoreProject.categories.forEach((category, index1) => {
      console.log("CATEGORIES : " + category.name + "  LENGTH : " + category.containers.length);
      if (category.containers.length == 1) {
        console.log("ONE CONTAINERS : " + category.name);
        category.assignedPoint = this.getCategoryAssignedPoints(project, category.uid);
        category.evalPoint = this.getCategoryPoint(project, category);
        category.constant = categoryContants[oneCategoryIndex] / category.assignedPoint;
        category.convertPoint = category.constant * category.evalPoint;
        console.log(oneCategoryIndex + " Categories POINTS : " + category.convertPoint);
        oneCategoryIndex++;
      }
      else {
        let containerIndex = 0;
        category.containers.forEach((container, index2) => {
          if (!container.containerValue.isExclude) {
            console.log("CONTAINERS : " + container.name);
            container.assignedPoint = this.getContainerAssignedPoints(project, container.uid);
            container.evalPoint = this.getContainerPoint(project, container);
            if (categoryIndex !== 0) {
              container.constant = containerContants[containerIndex] / container.assignedPoint;
            }
            container.convertPoint = container.constant * container.evalPoint;
            console.log("Container POINTS : " + container.convertPoint);
            category.assignedPoint += container.assignedPoint;
            category.evalPoint += container.evalPoint;
            if (categoryIndex !== 0) {
              category.convertPoint += container.convertPoint;
            }
          }
          console.log("ContainerIndex : " + containerIndex);
          containerIndex++;
        });
        if (categoryIndex === 0) {
          category.constant = 21 / category.assignedPoint;
          category.convertPoint = category.constant * category.evalPoint;
        }
      }
      scoreProject.totalAssginedPoints += category.assignedPoint;
      scoreProject.totalEvalPoints += category.evalPoint;
      scoreProject.totalConvertPoints += category.convertPoint;
      categoryIndex++;
    });

    return scoreProject;
  }

  static getItemLength(project: IPProject, container: IPContainer) {
    const filteredItems = container.items.filter(x => project.noContentItemUIDs.indexOf(x.uid) === -1);
    return filteredItems.length;
  }

  // note 배점 
  // 중분류 배점
  static getContainerAssignedPoints(project: IPProject, containerUID: number) {
    const container = this.getContainerByUID(project, containerUID);
    if (container.containerValue.isExclude) return 0;
    const filteredItems = container.items.filter(x => project.noContentItemUIDs.indexOf(x.uid) === -1);
    return filteredItems.length * 10;
  }

  // 대분류 배점
  static getCategoryAssignedPoints(project: IPProject, categoryUID: number) {
    const category = project.categories.find(x => x.uid === categoryUID);
    let totalPoint = 0;
    if (category) {
      category.containers.forEach(container => {
        if (!container.containerValue.isExclude) {
          totalPoint += this.getContainerAssignedPoints(project, container.uid);
        }
      });
    }
    return totalPoint;
  }

  // 프로젝트 배점
  static getProjectAssignedPoints(project: IPProject) {
    let totalPoint = 0;
    project.categories.forEach(category => totalPoint += this.getCategoryAssignedPoints(project, category.uid));
    return totalPoint;
  }

  // Container
  static getContainerByUID(project: IPProject, containerUID: number) {
    let container = {} as IPContainer;
    project?.categories?.forEach(x => x.containers?.forEach(y => { if (y.uid === containerUID) container = y; }));
    return container;
  }

  // note : updateContainer API 전송시 트래픽 감소를 위해 불필요한 데이터 제거
  static dietContainer(container: IPContainer) {
    const dietContainer = {} as IPContainer;
    dietContainer.categoryUID = container.categoryUID;
    dietContainer.items = container.items.map(x => ({ ...x }));
    dietContainer.items.forEach(item => {
      item.projectItemValues = [];
      item.guides = [];
    });
    return dietContainer;
  }

  static getItemByUIDs(project: IPProject, itemUID: number): IPItem {
    let item = {} as IPItem;
    project.categories.forEach(x => x.containers.forEach(y => y.items.forEach(z => { if (z.uid === itemUID) item = z; })));
    return item;
  }

  // note File Utility
  static getFile(file: File) {
    var reader = new FileReader();
    return new Promise<FileInfo>((resolve, reject) => {
      reader.onerror = () => {
        reader.abort();
        reject(new Error("Error parsing file"));
      };
      reader.onload = function () {
        let bytes = Array.from(new Uint8Array(this.result as ArrayBuffer));
        let base64StringFile = btoa(
          bytes.map((item) => String.fromCharCode(item)).join("")
        );
        resolve({
          bytes: bytes,
          base64StringFile: base64StringFile,
          fileName: file.name,
          fileType: file.type,
        });
      };
      reader.readAsArrayBuffer(file);
    });
  }

  static resizeImage(img: FileInfo, width: number, height: number) {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');

    canvas.width = width;
    canvas.height = height;

    const base64 = "data:" + img.fileType + ";base64," + img.base64StringFile;

    return new Promise<string>((resolve, reject) => {
      let image = new Image();
      image.src = base64;
      image.onload = () => {
        ctx?.drawImage(image, 0, 0, width, height);
        resolve(canvas.toDataURL(img.fileType, 0.6));
      }
    });
  }

  static resizeBase64Image(imageBase64: string, width: number, height: number) {
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');

    canvas.width = width;
    canvas.height = height;

    const fileType = imageBase64.substring("data:".length, imageBase64.indexOf(";base64"))

    return new Promise<string>((resolve, reject) => {
      let image = new Image();
      image.src = imageBase64;
      image.onload = () => {
        ctx?.drawImage(image, 0, 0, width, height);
        resolve(canvas.toDataURL(fileType, 0.6));
      }
    });
  }

  static async imageLoadedHandler(
    e: React.ChangeEvent<HTMLInputElement>,
    base64Handler: any,
    fileNameHandler?: any,
    resizeWidth?: number,
    resizeHeight?: number
  ) {
    e.preventDefault();
    const fileList = e.target.files;
    if (fileList !== undefined && fileList !== null && fileList.length > 0) {
      var file = fileList[0];
      IPUtility.getFile(file).then((fileInfoData) => {
        const fileName = fileInfoData.fileName;
        const base64 =
          "data:" +
          fileInfoData.fileType +
          ";base64," +
          fileInfoData.base64StringFile;
        if (fileNameHandler) fileNameHandler(fileName);
        if (resizeWidth && resizeHeight)
          this.resizeBase64Image(base64, resizeWidth, resizeHeight).then(data => base64Handler(data));
        else base64Handler(base64);
      });
    }
  }

  static async getConfiguration() {
    const response = await fetch("/API/GetConfiguration");
    const jsonData = await response.json();
    console.log(jsonData);
  }

  static getItemByPOST = async <T>(api: string, param: any) => {
    let count = 0;
    while (count < 5) {
      const json = await this.getItemsFromAPIAsync("/API/" + api, param);
      if (json) return json.item as T;
      count++;
    }
  }

  static getItemsFromAPIAsync = async (url: string, param: any, successHandler?: any, failHandler?: any) => {
    try {
      const methodName = "GET";
      const response = await fetch(url + "?" + new URLSearchParams(param), {
        method: methodName,
      });
      if (response.status == 200) {
        const json = await response.json();
        console.log("fetchOk!");
        if (json.status.indexOf("Ok!") > -1) {
          console.log("serverOk!");
          if (successHandler !== undefined) successHandler();
          return json;
        }
        else {
          console.log("serverFailed");
        }
      }
      else {
        console.log("fetchFailed" + response.status);
      }
      if (failHandler !== undefined) failHandler();
      console.log("fetchFailed");
      return null;
    }
    catch (e) { console.log(e); return null; }
  }

  // note --------------------------------------------------- NOT USED ---------------
  // TODO - 사용되지 않음 Deprecated 
  static getMyItemValue(project: IPProject, categoryUID: number, containerUID: number, itemUID: number): string {
    let itemValue = "none";
    const category = project.categories.find(category => category.uid === categoryUID);
    if (category !== undefined) {
      const container = category.containers.find(container => container.uid === containerUID);
      if (container !== undefined) {
        const item = container.items.find(x => x.uid === itemUID);
        if (item !== undefined) {
          itemValue = item.myItemValue.general;
        }
      }
    }
    return itemValue;
  }

  // TODO - 사용되지 않음 Deprecated 
  static setProjectValue(project: IPProject, categoryUID: number, containerUID: number, itemValue: IPItemValue) {
    const catIndex = project.categories.findIndex(category => category.uid === categoryUID);
    const category = project.categories[catIndex];
    const contIndex = category.containers.findIndex(container => container.uid === containerUID);
    const container = category.containers[contIndex];
    const itemIndex = container.items.findIndex(x => x.uid === itemValue.itemUID);
    container.items[itemIndex].myItemValue.general = itemValue.general;
  }

  // TODO - 사용되지 않음 Deprecated 
  static getProjectItemValuesByItemUID(
    project: IPProject,
    itemUID: number
  ): IPItemValue[] {
    project.categories.forEach((category) => {
      category.containers.forEach((container) => {
        const item = container.items.find((x) => x.uid == itemUID);
        if (item !== undefined) return item.projectItemValues;
      });
    });
    const items: IPItemValue[] = [];
    return items;
  }

  // TODO - 사용되지 않음 Deprecated 
  static setTextToItem(project: IPProject, itemUID: number, text: string) {
    project.categories.forEach((category) => {
      category.containers.forEach((container) => {
        const item = container.items.find((x) => x.uid === itemUID);
        if (item !== undefined) {
          item.myItemValue.general = text;
        }
      });
    });
  }

  // TODO - 사용되지 않음 Deprecated 

}
